module.exports = __webpack_public_path__ + "static/media/exit.93efc4b3.svg";